export const texts = {
  fr: {
    variante: {
      title: {
        fr: "variantes",
        de: "varianten",
        en: "variants",
      },
    },
    seo_title: "Prémur bas carbone : Précoffré® TH Green - FEHR Group",
    seo_description:
      "Le premier mur préfabriqué structurel de façade répondant aux défis de demain, isolation biosourcée à base de fibre de bois",
    title: "Précoffré® TH Green",
    copy: "Intégrant l’isolation biosourcée à base de fibre de bois permettant de répondre aux exigences de la RE2020, une formulation béton bas carbone réduisant le bilan carbone de 42% et la mise en œuvre de 100% de gravier recyclé dans le béton constituant le Précoffré® TH Green.",
    subtitle: "Le premier mur préfabriqué très bas carbone",
    pros: [
      {
        title: "Réduction de 42% des émissions de CO2",
        icon: "planet",
      },
      {
        title: "Rmur = jusqu’à 8,65 m2.K/W",
        icon: "building",
      },
      {
        title: "Livraison par camion gaz réduction de 20% d’émissions de CO2",
        icon: "cloud",
      },
      {
        title: "Durée de vie 100 ans 100 % recyclable",
        icon: "recycle",
      },
    ],
    cta: [
      {
        title: "Documentation",
        slug: "#download",
      },
      {
        title: "En savoir plus ↓",
        slug: "#main",
      },
    ],
    product_table: {
      title: "tableau comparatif",
      asterix:
        "Étude : comparatif solutions constructives Karibati, Montreuil - septembre 2020",
      table_data: {
        thead: [
          "Quantité de matières recyclées (% massique)",
          "Réchauffement climatique (kg eq CO2)",
        ],
        tr: [
          [
            {
              data: "Précoffré® TH Green Bas carbone",
            },
            {
              data_label: "Quantité de matières recyclées (% massique)",
              data: "39 %",
            },
            {
              data_label: "Réchauffement climatique (kg eq CO2)",
              data: "41,79",
            },
          ],
          [
            {
              data: "Voile béton + isolation par l'extérieur isolant 25cm PSE",
            },
            {
              data_label: "Quantité de matières recyclées (% massique)",
              data: "0%",
            },
            {
              data_label: "Réchauffement climatique (kg eq CO2)",
              data: "61,23",
            },
          ],
          [
            {
              data: "Mur à ossature bois + bardage composite bois, isolant 28cm fibre de bois",
            },
            {
              data_label: "Quantité de matières recyclées (% massique)",
              data: "0%",
            },
            {
              data_label: "Réchauffement climatique (kg eq CO2)",
              data: "64,40",
            },
          ],
        ],
      },
    },
    summary: [
      "Ce prémur thermique (mur en béton à coffrage et isolation intégrés) est composé de béton très bas carbone, d’un isolant biosourcé en fibre de bois et de menuiserie intégrée en usine.",
      "Le béton est formulé avec du ciment bas carbone (CEM III par exemple), associé à une adjuvantation optimisée pour garantir les performances habituelles. L’impact carbone est ainsi réduit de 42% par rapport à la solution conventionnelle (impact carbone du béton ~ 160 kg CO2/m3).",
      "L’isolation intégrée dans le Précoffré® TH Green est la fibre de bois en alternative au PSE ou à la mousse de PU utilisés habituellement, permettant ainsi de diviser par 5 l’impact carbone lié au choix de l’isolant. La mise en oeuvre d’une épaisseur d’isolant jusqu’à 34cm permet de répondre aux exigences les plus sévères pour des déperditions d’énergie minimales (performance globale du mur jusqu’à U = 0,116 W/m2.K ou R = 8,65 m2.K/W).",
    ],
    cards: [
      "Granulats issus de la déconstruction",
      "Isolant biosourcé adapté à la RE2020",
      "Mur 100% recyclable",
      "Menuiserie intégrée pour une étanchéité maximale air/eau",
      "Sécurité à la mise en oeuvre intégrée",
      "Parement et teinte personnalisables",
    ],
    twocol: [
      {
        img: "coupe",
        alt: "Photo de coupe",
      },
    ],
    downloads: {
      title: "Documentation",
      sections: [
        {
          title: "Documentation Précoffre® TH Green",
          slug: "documentation/premur/green/documentation_th_green.pdf",
        },
      ],
    },
  },
  de: {
    variante: {
      title: {
        fr: "variantes",
        de: "varianten",
        en: "variants",
      },
    },
    seo_title: "Thermowand Green : biobasierte Holzfaserdämmung - FEHR Group",
    seo_description:
      "Die erste strukturelle Fassadenwand, die den herausforderungen von morgen gerecht wird. Thermowand Green : biobasierte Holzfaserdämmung",
    title: "Thermowand Green",
    subtitle: "Die erste extrem kohlenstoffarme Fertigteilwand",
    copy: "Mit einer Dämmung aus Holzfasern auf Biobasis, die die Anforderungen von RE2020 erfüllt, einer kohlenstoffarmen Betonrezeptur, die den CO2-Fußabdruck um 42 % reduziert, und der Verwendung von 100 % recyceltem Kies im Beton des Precoffré® TH Green.",
    cta: [
      {
        title: "Mehr lesen ↓",
        slug: "#main",
      },
    ],
    pros: [
      {
        title: "42 % weniger CO2-Ausstoß",
        icon: "planet",
      },
      {
        title: "R-Wert der Wand = bis zu 8,65 m2.K/W",
        icon: "building",
      },
      {
        title: "Lieferung mit gasbetriebenen Lkw 20 % weniger CO2-Emissionen",
        icon: "cloud",
      },
      {
        title: "100 Jahre Lebensdauer 100 % recyclebar",
        icon: "recycle",
      },
    ],
    product_table: {
      title: "Vergleichstabelle",
      author:
        "Studie : Vergleich konstruktiver Lösungen Karibati, Motreuil - Sept 2020. Studie an der auf S.2 beschriebenen Wand durchgeführt",
      table_data: {
        thead: [
          "Menge an recyceltem Material [Massenanteil]",
          "Globale Erwärmung [kg CO2e]",
        ],
        tr: [
          [
            {
              data: "Thermowand Green (28cm Holzfaser-Dämmstoff)",
            },
            {
              data_label: "Menge an recyceltem Material [Massenanteil]",
              data: "39 %",
            },
            {
              data_label: "Globale Erwärmung [kg CO2e]",
              data: "41,79",
            },
          ],
          [
            {
              data: "Betonschale + AuBendämmung (25cm PSE-Dämmstoff)",
            },
            {
              data_label: "Menge an recyceltem Material [Massenanteil]",
              data: "0%",
            },
            {
              data_label: "Globale Erwärmung [kg CO2e]",
              data: "61,23",
            },
          ],
          [
            {
              data: "Holzständerwand + Fassadenverkleidung aus Holzverbundstoffen (28cm Holzfaser-Dämmstoff)",
            },
            {
              data_label: "Menge an recyceltem Material [Massenanteil]",
              data: "0%",
            },
            {
              data_label: "Globale Erwärmung [kg CO2e]",
              data: "64,40",
            },
          ],
        ],
      },
    },
    summary: [
      "Diese thermische Vormauerung (Betonwand mit integrierter Schalung und Isolierung) besteht aus Beton mit sehr niedrigem Kohlenstoffgehalt, einer biobasierten Holzfaserisolierung und werkseitig eingebauten Tischlerarbeiten",
      "Der Beton wird mit kohlenstoffarmem Zement (z. B. CEM III) formuliert und mit einem optimierten Zusatzstoff kombiniert, um die üblichen Leistungen zu gewährleisten. Die CO2-Belastung wird so im Vergleich zur herkömmlichen Lösung um 42% reduziert (CO2-Belastung des Betons ~ 160 kg CO2/m3)",
      "Die in Precoffré® TH Green integrierte Dämmung besteht aus Holzfasern als Alternative zum üblicherweise verwendeten EPS oder PU-Schaum, wodurch der mit der Wahl der Dämmung verbundene CO2-Ausstoß um das Fünffache reduziert werden kann. Durch den Einsatz einer Dämmstoffdicke von bis zu 36 cm können die strengsten Anforderungen bei minimalen Energieverlusten erfüllt werden (Gesamtleistung der Wand bis zu U = 0,105 W/m2.K oder R = 8,65 m2.K/W).",
    ],
    twocol: [
      {
        img: "coupe",
        alt: "Photo de coupe",
      },
    ],
    cards: [
      "Sehr kohlenstoffarmer Beton",
      "Aggregate aus dem Rückbau",
      "Dämmung auf Holzfaserbasis",
      "Dämmung auf Holzfaserbasis",
      "Integrierte Fenster-Schreinerei für maximale Luft-/Wasserdichtheit",
      "Integrierte Sicherheit",
      "Individuell gestaltbarer Textur und Farbe",
    ],
  },
  en: {
    variante: {
      title: {
        fr: "variantes",
        de: "varianten",
        en: "variants",
      },
    },
    seo_title: "Precast Wall TH Green : reduced carbon footprint - FEHR Group",
    seo_description:
      "Precast wall TH Green : the first structural exterior wall that can take on the challenges of the future. The calculated carbon impact of this formulation is 160 kg CO2/m3 of concrete, compared to 278 kg CO2/m3 for the standard formulation using CEM I",
    title: "Precast Wall TH Green",
    subtitle: "The first ultra-low-carbon prefabricated wall",
    copy: "Incorporating biosourced insulation based on wood fiber, meeting the requirements of RE2020, a low-carbon concrete formulation reducing the carbon footprint by 42%, and the use of 100% recycled gravel in the concrete making up the Precoffré® TH Green.",
    pros: [
      {
        title: "42% reduction in CO2 emissions",
        icon: "planet",
      },
      {
        title: "Rmur = up to 9.5 m2.K/W",
        icon: "building",
      },
      {
        title: "Gas truck delivery reduces CO2 emissions by 20%",
        icon: "cloud",
      },
      {
        title: "Lifespan 100 years 100% recyclable",
        icon: "recycle",
      },
    ],
    cta: [
      {
        title: "Read more ↓",
        slug: "#main",
      },
    ],
    product_table: {
      title: "Comparative table",
      author:
        "Study: comparative constructive solutions by Karibati, Montreuil - September 2020",
      table_data: {
        thead: [
          "Amount of recycled materials (% by weight)",
          "Global warming potential (kg eq CO2)",
        ],
        tr: [
          [
            {
              data: "Precoffré® TH Green Low Carbon",
            },
            {
              data_label: "Amount of recycled materials (% by weight)",
              data: "39%",
            },
            {
              data_label: "Global warming potential (kg eq CO2)",
              data: "41.79",
            },
          ],
          [
            {
              data: "Concrete veil + exterior insulation 25cm PSE",
            },
            {
              data_label: "Amount of recycled materials (% by weight)",
              data: "0%",
            },
            {
              data_label: "Global warming potential (kg eq CO2)",
              data: "61.23",
            },
          ],
          [
            {
              data: "Wooden frame wall + composite wood cladding, 28cm wood fiber insulation",
            },
            {
              data_label: "Amount of recycled materials (% by weight)",
              data: "0%",
            },
            {
              data_label: "Global warming potential (kg eq CO2)",
              data: "64.40",
            },
          ],
        ],
      },
    },
    summary: [
      "This thermal premur (concrete wall with integrated formwork and insulation) is composed of very low-carbon concrete, biosourced wood fiber insulation and factory-integrated joinery.",
      "The concrete is formulated with low-carbon cement (CEM III, for example), combined with an optimized admixture to guarantee the usual performances. The carbon impact is thus reduced by 42% compared with the conventional solution (carbon impact of concrete ~ 160 kg CO2/m3).",
      "The insulation used in Précoffré® TH Green is wood fiber, as an alternative to the EPS or PU foam normally used, enabling the carbon impact associated with the choice of insulation to be divided by 5. Insulation thicknesses of up to 34cm meet the most stringent requirements for minimum energy loss (overall wall performance up to U = 0.105 W/m2.K or R = 9.5 m2.K/W).",
    ],
    cards: [
      "Very low carbon concrete",
      "Aggregates from deconstruction",
      "Biosourced insulation adapted to RE2020",
      "100% recyclable wall",
      "Integrated joinery for maximum air/water tightness",
      "Integrated safety during installation",
      "Customizable cladding and color",
    ],
    twocol: [
      {
        img: "coupe",
        alt: "Photo de coupe",
      },
    ],
  },
}
